import { InlineLoader } from './inline-loader'

function LoadingSpinner() {
  return (
    <div className='absolute inset-0 flex items-center justify-center'>
      <InlineLoader size='lg' />
    </div>
  )
}

export default LoadingSpinner
